"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../../utils");

var _Copy = require("../../../utils/Copy");

var _dataProcessors = require("../../../utils/dataProcessors");

var _LocationInfo = _interopRequireDefault(require("../LocationInfo"));

var _TableInfo = _interopRequireDefault(require("../TableInfo"));

var _MarketInfo = _interopRequireDefault(require("../MarketInfo"));

var _utils2 = require("../utils");

var _excluded = ["restaurantLogo", "themeType", "infoThemeType", "backgroundImage", "bannerInfo", "cells", "diningOption", "infoType", "location", "locationInfoHours", "tableNumber", "onSeeFullMenu", "onKioskChange", "tableInfoCopy"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var KIOSK = _utils.constants.ORDER_TYPES.KIOSK;

var withBanner = function withBanner(Component) {
  return function (_ref) {
    var restaurantLogo = _ref.restaurantLogo,
        themeType = _ref.themeType,
        infoThemeType = _ref.infoThemeType,
        backgroundImage = _ref.backgroundImage,
        bannerInfo = _ref.bannerInfo,
        cells = _ref.cells,
        diningOption = _ref.diningOption,
        infoType = _ref.infoType,
        _location = _ref.location,
        _ref$locationInfoHour = _ref.locationInfoHours,
        locationInfoHours = _ref$locationInfoHour === void 0 ? [] : _ref$locationInfoHour,
        tableNumber = _ref.tableNumber,
        onSeeFullMenu = _ref.onSeeFullMenu,
        onKioskChange = _ref.onKioskChange,
        tableInfoCopy = _ref.tableInfoCopy,
        props = _objectWithoutProperties(_ref, _excluded);

    var cellType = diningOption === KIOSK ? cells.kiosk : cells.location;
    var bannerContentMap = {
      location: function location() {
        if (!_location) return null;
        var _location$address = _location.address,
            address = _location$address === void 0 ? {} : _location$address,
            name = _location.name,
            phone = _location.phone,
            _location$hours = _location.hours,
            hours = _location$hours === void 0 ? [] : _location$hours;
        var day = new Date().getDay();
        var hour = hours.find(function (i) {
          return i.day === day;
        }) || {};
        var locationInfoHour = (locationInfoHours === null || locationInfoHours === void 0 ? void 0 : locationInfoHours.find(function (i) {
          return i.day === day;
        })) || {};

        var _getHoursInfo = (0, _utils2.getHoursInfo)({
          hour: hour,
          locationInfoHour: locationInfoHour,
          diningOption: diningOption
        }),
            label = _getHoursInfo.label,
            open = _getHoursInfo.open,
            close = _getHoursInfo.close,
            displayHour = _getHoursInfo.displayHour;

        return /*#__PURE__*/_react["default"].createElement(_LocationInfo["default"], {
          infoThemeType: infoThemeType,
          cellType: cellType,
          name: name,
          phone: (0, _dataProcessors.formatPhoneNumber)(phone.value),
          address: (0, _dataProcessors.formatAddress)(address),
          label: label,
          open: open,
          close: close,
          dineInOpen: hour.dineInOpen,
          dineInClose: hour.dineInClose,
          restaurantLogo: restaurantLogo,
          displayHour: displayHour,
          displayHourDineIn: locationInfoHour.dineIn
        });
      },
      market: function market() {
        var bannerDesc = bannerInfo.bannerDesc,
            bannerLogo = bannerInfo.bannerLogo,
            bannerTitle = bannerInfo.bannerTitle;
        return /*#__PURE__*/_react["default"].createElement(_MarketInfo["default"], {
          infoThemeType: infoThemeType,
          cellType: cellType,
          bannerLogo: bannerLogo,
          bannerTitle: bannerTitle,
          bannerDesc: bannerDesc,
          onSeeFullMenu: onSeeFullMenu
        });
      },
      table: function table() {
        return /*#__PURE__*/_react["default"].createElement(_TableInfo["default"], {
          infoThemeType: infoThemeType,
          cellType: cellType,
          tableNumber: tableNumber || "&nbsp;",
          selectorText: (tableInfoCopy === null || tableInfoCopy === void 0 ? void 0 : tableInfoCopy.tableInfoHeaderCopy) || _Copy.Copy.KIOSK_STATIC.TABLE_SELECTOR_TEXT,
          selectorButton: (tableInfoCopy === null || tableInfoCopy === void 0 ? void 0 : tableInfoCopy.tableInfoEditBtnCopy) || _Copy.Copy.KIOSK_STATIC.TABLE_SELECTOR_BUTTON,
          onClick: onKioskChange
        });
      }
    };
    var bannerContent = bannerContentMap[infoType]();
    var returnProps = {
      backgroundImage: backgroundImage,
      bannerContent: bannerContent,
      themeType: themeType
    };
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, returnProps));
  };
};

var _default = withBanner;
exports["default"] = _default;